// Route names, apart from `routes.ts` so components can link to them without importing the route
// table (which lazily imports those same components).
export const PLATFORM_ACTIONS_ROUTE_NAME = 'PlatformActions'
export const CHANGE_DETAIL_ROUTE = 'PlatformActionChangeDetail'

/** `?tab=` values the page reads — the change detail links back to the decisions tab. */
export const APPROVALS_TAB = 'decisions'
export const CHANGES_TAB = 'all'
